import React from 'react';
import { Spinner } from '@shopify/polaris';

export function LoadingSpinner({ size = 'large' }) {
  return <Spinner accessibilityLabel='Spinner' size={size} />;
}
